import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';




function depositentry() {


    return (

        <Card className='mt-2'>
            <Card.Body>
                <Row>
                    <Col sm={2}>
                        <b className='h6 fss-05'>USER TYPE</b>
                    </Col>

                    <Col sm={4}>

                        <Form.Select aria-label="Default select example" className='text-black bg-light'>
                            <option></option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </Form.Select>

                    </Col>



                </Row>


                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className='h6 fss-05'>SELECT</b>
                    </Col>

                    <Col sm={4}>

                        <Form.Select aria-label="Default select example" className='text-black bg-light'>
                            <option></option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </Form.Select>
                    </Col>
                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className='h6 fss-05'>TYPE</b>
                    </Col>

                    <Col sm={1}>

                        {['radio'].map((type) => (
                            <div key={`inline-${type}`} className="mb-3">
                                <Form.Check
                                    inline
                                    label="DEPOSIT"
                                    className='h6 fss-05'
                                    name="group1"
                                    type={type}
                                    id={`inline-${type}-1`}
                                />
                                <Form.Check
                                    inline
                                    label="WITHDRAW"
                                    className='h6 fss-05'
                                    name="group1"
                                    type={type}
                                    id={`inline-${type}-1`}
                                />

                            </div>
                        ))}
                    </Col>
                </Row>


                <Row className='mt-2'>
                    <Col sm={2}>
                        <b className='h6 fss-05'>DATE</b>
                    </Col>

                    <Col sm={4}>
                        <input className="form-control text-black bg-light" type="date" size="lg"
                        />

                    </Col>


                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className='h6 fss-05'>AMOUNT</b>
                    </Col>

                    <Col sm={4}>

                        <input type='number' className='bg-light text-black form-control' />

                    </Col>


                </Row>


                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className='h6 fss-05'>REMARKS</b>
                    </Col>

                    <Col sm={4}>

                        <input type="text" className="form-control text-black bg-light" id="exampleFormControlInput1" />
                    </Col>
                </Row>

                <Row className='mt-2'>
                    <Col sm={2}>

                    </Col>

                    <Col sm={4}>
                        <Button variant="secondary">Save</Button>{' '}
                        <Button variant="danger">Clear</Button>{' '}

                    </Col>
                </Row>



            </Card.Body>
        </Card>


    );
}
export default depositentry;